import { combineReducers } from '@ngrx/store';
import { reducer as activeCustomerReducer } from 'app/core/store/session/active-customer/active-customer.reducer';
import { reducer as selectedCustomerReducer } from 'app/core/store/session/selected-customer/select-customer.reducer';
import { SessionState } from 'app/core/store/session/session.interface';
import { reducer as userContextReducer } from 'app/core/store/session/user-context/user-context.reducer';
import { reducer as authorizationReducer } from './authorization/authorization.reducer';
import { reducer as customerPermissionsReducer } from './customer-permissions/customer-permissions.reducer';

export function reducer(state: SessionState, action: any): SessionState {
  return combineReducers({
    _activeCustomer: activeCustomerReducer,
    authorization: authorizationReducer,
    customerPermissions: customerPermissionsReducer,
    selectedCustomer: selectedCustomerReducer,
    userContext: userContextReducer,
  })(state, action);
}
